import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const SoapReportSlice = createSlice({
  name: "SoapReportSlice",
  initialState: {},
  reducers: {},
});
export const addSoapReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const { request_id = "" } = payload || {};

      // Ensure `request_id` is included in the payload
      const requestBody: any = {
        request_id,
      };

      // Make the API request with the constructed body
      const res = await api.post(API_URL.SOAP_REPORTS.ADD, requestBody);
      return Promise.resolve(res.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListSoapReports =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      // Destructure payload with default values
      const { report_date = "", current = 1, page_size = 10 } = payload || {};

      // Construct the query string dynamically
      const actionParts = [
        `report_date=${report_date}`,
        `current=${current}`,
        `page_size=${page_size}`,
      ];

      // Join query parts
      const action = `?${actionParts.join("&")}`;

      // Make the API call
      const response = await api.get(API_URL.SOAP_REPORTS.LIST + action);

      // Return the response data
      return Promise.resolve(response?.data?.data);
    } catch (error: any) {
      // Improved error handling
      return Promise.reject(error?.response?.data || error.message);
    }
  };

export const deleteSoapReports =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.SOAP_REPORTS.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default SoapReportSlice.reducer;
